export default __webpack_public_path__ + "static/media/NFTnodeVer3_1.6b02e7d0.svg";